import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormConstants } from '../../../../constants/form.constants';
import { FormHeaderInfo } from '../../../../models/form-header-info.model';
import { NavigationService } from '../../../../services/navigation.service';
import { Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-form-header',
  templateUrl: './form-header.component.html',
  styleUrls: ['./form-header.component.scss']
})
export class FormHeaderComponent implements OnInit, OnDestroy {
  usanFormType!: string;
  private subscriptions: Subscription[] = [];
  private mobileDeviceSize: boolean = false;

  constructor(
    protected navigationService: NavigationService, 
    protected formService: FormService, 
    private router: Router, 
    private responsive: BreakpointObserver
  ) {
    let usanFormTypeSubscription = this.navigationService.getUsanFormTypeUpdate().subscribe(
      formType => {
        this.usanFormType = formType.value;
        this.updateFormInfo();
      });
    this.usanFormType = this.navigationService.getUsanFormTypeValue();
    this.subscriptions.push(usanFormTypeSubscription);
  }

  formInfo!: FormHeaderInfo;

  ngOnInit(): void {
    this.updateFormInfo();
    
    let sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if(result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });

    this.subscriptions.push(sizeChangeSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => {
      if(sub) {
        sub.unsubscribe();
      }
    });
  }

  clickAction() {
    this.formService.unlockCase().subscribe();
    this.router.navigate(["/usan"]);
  }

  private updateFormInfo() {
    const form = FormConstants.FORM_INFO_MAP.get(this.usanFormType);
    this.formInfo = form ? form : FormConstants.EMPTY_FORM_INFO;
  }  

  get formHeaderTitle() {
    return this.formInfo.formName;
  }

  get formPurposeDescription() {
    return this.formInfo.formPurpose;
  }

  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }

}
